import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { trackPageView } from '@/analytics/mixpanel'

const CLARITY_ID = '4haye5goh3'

const isBlockedPath = (pathname) => {
  // Keep analytics off on PropertyEdge Property Search because of cross-origin iframe behavior.
  if (!pathname) return false
  return (
    pathname === '/property-search' ||
    pathname.startsWith('/property-search/')
  )
}

const ensureScript = ({ id, src  }) => {
  if (document.getElementById(id)) return
  /** @type {HTMLScriptElement} */
  const s = document.createElement('script')
  s.id = id
  s.async = true
  s.src = src
  document.head.appendChild(s)
}

const loadClarity = () => {
  if (window['__HF_CLARITY_LOADED']) return
  window['__HF_CLARITY_LOADED'] = true

  // Minimal Clarity loader with a queueing stub + injected script.
  if (typeof window['clarity'] !== 'function') {
    window['clarity'] = function () {
      // @ts-ignore - allow attaching queue to function
      ;(window['clarity'].q = window['clarity'].q || []).push(
        arguments,
      )
    }
  }

  ensureScript({
    id: 'hf-clarity',
    src: 'https://www.clarity.ms/tag/' + CLARITY_ID,
  })
}

const stopClarityIfPresent = () => {
  try {
    const clarity = window['clarity']
    if (typeof clarity === 'function') clarity('stop')
  } catch (e) {
    // ignore
  }
}

const AnalyticsLoader = () => {
  const location = useLocation()
  const blocked = isBlockedPath(location.pathname)

  useEffect(() => {
    if (blocked) {
      stopClarityIfPresent()
      return
    }

    // External script analytics
    loadClarity()

    // Mixpanel SPA page views (default event name: $mp_web_page_view)
    trackPageView({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      title: document.title,
    })
  }, [blocked, location.pathname, location.search])

  return null
}

export default AnalyticsLoader
